module.exports = __webpack_public_path__ + "images/places/training_730-501fb14bd15decf286e4177c40d31591.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/training_730.jpg
 ** module id = 327
 ** module chunks = 0
 **/